import React from "react";
import { Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const MailConfigurationsList = () => {
  const mailConfigurations = useSelector(
    (state) => state.mailConfiguration.mailConfigurations
  );
  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title>Mail Servers List</Card.Title>
      </Card.Header>
      <Card.Body>
        <Table responsive hover>
          <thead>
            <tr>
              <th>Domain/Tenant</th>
              <th>Status</th>
              <th>Last Checked</th>
            </tr>
          </thead>
          <tbody>
            {mailConfigurations.map((mailConfiguration) => {
              return (
                <tr>
                  <td>{mailConfiguration.domain}</td>
                  <td>
                    <div
                      className={`circle ${
                        mailConfiguration.healthStatus === "UP"
                          ? "pulse green"
                          : mailConfiguration.healthStatus === "DOWN"
                          ? "red"
                          : "blue"
                      }`}
                    />
                  </td>
                  <td>{mailConfiguration.lastCheckedAt}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default MailConfigurationsList;
